/* ナビジョン 50%OFF セール LP 用スクリプト
 *
 * 役割:
 *   1. 購入導線 [data-navision-buy]: オプション選択からバリアントを解決し、
 *      チェックアウト URL・価格表示・特商法表示を更新する。
 *      オファーセクションの大きいカードと、グリッドの各商品カードで共通。
 *   2. 追従 CTA [data-navision-sticky]: スクロール量に応じて表示し、
 *      オファーが画面内にある間は隠す。
 *
 * 価格文字列は Liquid 側で money 整形済みのものを JSON から受け取るため、
 * ここでは通貨計算・整形を一切行わない。
 */
(function () {
  'use strict';

  /* ---------- 購入導線 ---------- */

  function initBuy(root) {
    if (root.dataset.nvsInit === 'true') return;

    var dataEl = root.querySelector('[data-navision-product-data]');
    var cta = root.querySelector('[data-navision-cta]');
    if (!dataEl || !cta) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      // 商品データが壊れている場合は導線を無効化し、他のカードの動作は止めない
      cta.disabled = true;
      return;
    }
    if (!data || !data.variants || !data.variants.length) return;

    root.dataset.nvsInit = 'true';

    var optionInputs = Array.prototype.slice.call(
      root.querySelectorAll('[data-navision-option]')
    );
    var inputId = root.querySelector('[data-navision-input-id]');
    var inputPlan = root.querySelector('[data-navision-input-plan]');
    var ctaText = cta.textContent.trim();
    var soldoutText = cta.dataset.soldoutText || '在庫切れ';

    var el = {
      off: root.querySelector('[data-navision-price-off]'),
      base: root.querySelector('[data-navision-price-base]'),
      first: root.querySelector('[data-navision-price-first]'),
      termPlan: root.querySelector('[data-navision-term-plan]'),
      termFirst: root.querySelector('[data-navision-term-first]'),
      termNext: root.querySelector('[data-navision-term-next]'),
      termNextRow: root.querySelector('[data-navision-term-next-row]')
    };

    // 選択中のオプション値を、Liquid 側の options 配列と同じ順序で組み立てる
    function selectedOptions() {
      var values = [];
      optionInputs.forEach(function (input) {
        var index = parseInt(input.dataset.optionIndex, 10);
        if (isNaN(index)) return;
        if (input.type === 'radio' && !input.checked) return;
        values[index] = input.value;
      });
      return values;
    }

    function findVariant() {
      var wanted = selectedOptions();
      var candidates = data.variants.filter(function (variant) {
        return wanted.every(function (value, index) {
          return value === undefined || variant.options[index] === value;
        });
      });
      if (!candidates.length) return null;
      // 在庫のあるものを優先する
      var available = candidates.filter(function (v) {
        return v.available;
      });
      return available.length ? available[0] : candidates[0];
    }

    function setText(node, value) {
      if (node) node.textContent = value || '';
    }

    function render() {
      var variant = findVariant();
      // 1 バリアントに複数プランが紐付いた場合（セール用プランを新規追加した等）に
      // 先頭を無条件に使うと割引の小さい方を掴む恐れがあるため、
      // 初回割引が最も大きいプランを選ぶ。
      var plan = null;
      if (variant && variant.plans.length) {
        plan = variant.plans.reduce(function (best, p) {
          return !best || p.off > best.off ? p : best;
        }, null);
      }

      if (!variant || !plan || !variant.available) {
        cta.disabled = true;
        cta.textContent = variant && !variant.available ? soldoutText : ctaText;
        if (inputId) inputId.value = '';
        if (inputPlan) inputPlan.value = '';
        setText(el.first, variant ? variant.price : '');
        setText(el.base, '');
        if (el.off) el.off.hidden = true;
        setText(el.termPlan, '-');
        setText(el.termFirst, variant ? variant.price : '-');
        if (el.termNextRow) el.termNextRow.hidden = true;
        return;
      }

      cta.disabled = false;
      cta.textContent = ctaText;
      // /cart/add への POST 内容を選択中のバリアントとプランで更新する
      if (inputId) inputId.value = variant.id;
      if (inputPlan) inputPlan.value = plan.id;

      setText(el.first, plan.first);

      // 割引が無いプランでは通常価格の打ち消しと OFF バッジを出さない
      if (plan.off > 0) {
        setText(el.base, variant.price);
        if (el.off) {
          el.off.hidden = false;
          el.off.textContent = plan.off + '%OFF';
        }
      } else {
        setText(el.base, '');
        if (el.off) el.off.hidden = true;
      }

      setText(el.termPlan, plan.name);
      setText(el.termFirst, plan.first);
      setText(el.termNext, plan.next);
      if (el.termNextRow) el.termNextRow.hidden = false;
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-navision-option]')) render();
    });

    // カートに入れるだけで、チェックアウトには遷移させない。
    // 素の POST だと return_to 先へ画面遷移してしまうため、
    // fetch で /cart/add.js を叩いてページに留まる。
    var form = root.querySelector('[data-navision-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (cta.disabled) return;

        var body = new FormData(form);
        body.delete('return_to');

        var busyText = cta.dataset.busyText || '追加中...';
        var doneText = cta.dataset.doneText || 'カートに追加しました';
        cta.disabled = true;
        cta.textContent = busyText;

        fetch('/cart/add.js', {
          method: 'POST',
          body: body,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            cta.textContent = doneText;

            // テーマ(component-cart.js)が公開している更新関数を呼ぶ。
            // ヘッダーのカート件数・金額とカートドロワーの中身を描き直すので、
            // リロードなしで反映される。
            if (typeof window.refreshCart === 'function') {
              window.refreshCart();
            } else {
              // 想定外に関数が無い場合でも件数だけは合わせておく
              fetch('/cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  document
                    .querySelectorAll('[data-header-cart-count]')
                    .forEach(function (elm) {
                      elm.textContent = cart.item_count;
                    });
                })
                .catch(function () {});
            }

            setTimeout(function () {
              cta.textContent = ctaText;
              cta.disabled = false;
            }, 2000);
          })
          .catch(function () {
            cta.textContent = ctaText;
            cta.disabled = false;
          });
      });
    }

    render();
  }

  /* ---------- 追従 CTA ---------- */

  function initSticky(bar) {
    if (bar.dataset.nvsInit === 'true') return;

    var targetId = (bar.dataset.target || '').replace(/^#/, '');
    var target = targetId
      ? document.getElementById(targetId)
      : document.querySelector('[data-navision-offer]');

    // オファーが 1 つも無いページでは追従 CTA を出さない
    if (!target) return;

    bar.dataset.nvsInit = 'true';

    var button = bar.querySelector('[data-navision-sticky-button]');
    if (button) {
      button.setAttribute('href', '#' + target.id);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'start'
        });
      });
    }

    bar.hidden = false;

    var threshold = parseInt(bar.dataset.showAfter, 10);
    if (isNaN(threshold)) threshold = 15;

    // オファーが画面内にある間は追従 CTA を隠す（同じ導線の二重表示を避ける）
    var offerVisible = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          offerVisible = entries[0].isIntersecting;
          update();
        },
        { threshold: 0.15 }
      ).observe(target);
    }

    function update() {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      var ratio = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
      bar.classList.toggle('is-visible', ratio >= threshold && !offerVisible);
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    update();
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-navision-buy]').forEach(initBuy);
    context.querySelectorAll('[data-navision-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // テーマエディタでセクションを編集したときに再初期化する
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
